<template>
  <WizardDetailWrapper
    :title="
      getComponentUiText(
        'app-menu-submenu-home-setup-wizard-sites-wrapper-question-title-1',
      )
    "
    :show-accordion="item.isCollapse"
    :data="data"
    :validation="v$.details"
    :page-active="idPage.teamsPage"
    :class="['tw-mb-[25px]']"
    :is-api-error="statusInPageClone"
    @update:accordion="item.isCollapse = !item.isCollapse"
  >
    <template #title>
      <div style="position: relative; width: 100%">
        <input
          v-model="item.details"
          class="enter__name"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-team-placeholder-input-1',
            )
          "
          style="border: unset; background-color: unset"
          @input="updateStore(item, 'details')"
          @click.stop
        />
        <span
          v-if="!item.details"
          style="position: absolute; left: 130px; top: -3px; color: red"
          >*</span
        >
      </div>
    </template>
    <MoreDetails
      :classes-more-detail="'!tw-p-0'"
      :is-show-questions="false"
      :is-details="item.id || isValidForm || item.showMoreDetail"
      :is-details-validate="item.showMoreDetail"
      @update:model-value="item.showMoreDetail = $event"
    />
    <div
      :class="[
        'more-detail-container tw-flex tw-flex-col tw-gap-[20px]',
        item.showMoreDetail === true || item.showMoreDetail === undefined
          ? 'show'
          : '',
      ]"
    >
      <WizardDropdown
        :id="`teamType-${item.id}`"
        v-model="item.teamTypeId"
        :required="true"
        :validation="v$.teamTypeId"
        :is-api-error="
          statusInPageClone && item.id && statusInPageClone.teamTypeId
        "
        :placeholder="
          getComponentUiText(
            'app-wizards-setup-wizard-more-details-select-text-1',
          )
        "
        :title="
          getComponentUiText(
            'app-component-wizards-setup-wizard-more-detail-staff-type-title-1',
          )
        "
        :data="dropdownTypeData"
        :use-visual-scroll="true"
        @update:value-team-page="updateStore(item, 'teamTypeId')"
      />
      <WizardDropdown
        :id="`country`"
        v-model="item.teamLegalTypeId"
        :validation="v$.teamLegalTypeId"
        :is-api-error="
          statusInPageClone && item.id && statusInPageClone.teamLegalTypeId
        "
        :required="true"
        :placeholder="
          getComponentUiText(
            'app-wizards-setup-wizard-more-details-select-text-1',
          )
        "
        :title="
          getComponentUiText(
            'app-component-wizards-setup-wizard-more-detail-staff-legal-type-title-1',
          )
        "
        :data="dropdownLegelTypeData"
        :use-visual-scroll="true"
        @update:value-team-page="updateStore(item, 'teamLegalTypeId')"
      />
      <WizardInputQuestion
        v-model="item.headcount"
        :type="INPUT_TYPE.number"
        :title="
          getComponentUiText(
            'app-component-wizards-setup-wizard-more-detail-staff-quantity-title-1',
          )
        "
        :required="true"
        :validation="v$.headcount"
        :is-api-error="
          statusInPageClone && item.id && statusInPageClone.headcount
        "
        :placeholder="
          getComponentUiText(
            'app-wizards-setup-wizard-more-details-select-text-1',
          )
        "
        :class-title="'tw-text-[14px] !tw-leading-[100%]'"
        @update:value-team-page="updateStore(item, 'headcount')"
      />
    </div>
  </WizardDetailWrapper>
</template>

<script setup lang="ts">
import { computed, reactive, Ref, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import MoreDetails from "./moreDetails.vue";

import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import store from "@/store";
import {
  INPUT_TYPE,
  WIZARD_STATE_NAME,
  idWizardPage as idPage,
  statusPage,
} from "@/utils/constants";
import WizardDropdown from "./wizardDropdown.vue";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
const emits = defineEmits([
  "onUpdate",
  "update:answer",
  "changeStatusAddTeams",
  "update:value:store",
]);
import { isHeadCount } from "@/utils/utilities";
const currentOrg = computed(() => store.state.Org.currentOrg);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});
const item = reactive({ ...props.data.item });
const questionSectionValue = computed(() => {
  const data = store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.TEAMS,
    currentOrg.value.id || null,
  );
  return data ? data[0].types : [];
});

const bodyAPIError = computed(() => {
  if (!item.id && props.statusInPage.dataError.length > 0 && item.isCallAPI) {
    return true;
  }
  return item.id && props.statusInPage.dataError.find((i) => i.id === item.id);
});

const statusInPageClone = ref(bodyAPIError);

const isValidForm: Ref<string> = ref("");

const updateStore = (item, updateKey) => {
  item.isCallAPI = false;
  statusInPageClone.value &&
    statusInPageClone.value[updateKey] &&
    delete statusInPageClone.value[updateKey];

  emits("update:value:store", { data: item, index: props.data.index });
  emits("changeStatusAddTeams", true);
};

const dropdownTypeData = computed(() => {
  return questionSectionValue.value.find((item) => item.typeId === "staff_type")
    ?.typeValues;
});
const dropdownLegelTypeData = computed(() => {
  return questionSectionValue.value.find(
    (item) => item.typeId === "staff_legal_type",
  )?.typeValues;
});

const rules = {
  details: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  teamTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  teamLegalTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  headcount: {
    headcount: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-wizards-setup-wizard-message-validate-staff-quantity-1",
        ),
      isHeadCount,
    ),
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
let v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  const isValid = !v$.value.$errors || v$.value.$errors.length === 0;
  if (!isValid) {
    isValidForm.value = "1";
  }
  return !v$.value.$error;
};

watch(props.statusInPage, (value) => {
  if (value.statusPage === statusPage.CallApi) item.isCallAPI = true;
});

defineExpose({
  saveChanges,
});
</script>
<style lang="scss" scoped>
.detail-container {
  margin: 0;
  padding: 0;
  height: 0px;
  overflow: hidden;
  transition:
    height 0.3s ease,
    padding 0.3s ease;

  &.show {
    padding-top: 12px;
    height: auto;
    overflow: visible;
  }
}

.more-detail-container {
  margin: 0;
  padding: 0;
  height: 0px;
  overflow: hidden;
  transition:
    height 0.3s ease,
    padding 0.3s ease;

  &.show {
    border-top: 1px solid #eff0f1;
    margin: 0px -25px -25px -25px;
    padding: 25px;
    height: auto;
    overflow: visible;
  }
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  color: #211f58;
  width: 98%;
}
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}
</style>
